import {Component, inject} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {MatButton} from '@angular/material/button'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'
import {MatFormField, MatInput, MatLabel} from '@angular/material/input'
import {INewOwner} from '../new-case/new-case'

@Component({
  selector: 'spb-get-name',
  imports: [
    FormsModule,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatInput,
    MatLabel
  ],
  templateUrl: './get-name.html',
  styleUrl: './get-name.scss',
})
export class GetName {
  public owner = inject<INewOwner>(MAT_DIALOG_DATA)
}
